import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import type { Entity } from 'src/app/core/models/entity.model';
import type { PropertyType } from 'src/app/core/models/property-type.model';
import type { EntityEditorPropertyChangedEvent } from 'src/app/entity-editor/models/entity-editor-property-changed.event';
import type { PropertyEditorInputs } from '../../../entity-editor/containers/property-editor-inputs';
import { PropertyComponentType, resolveComponentType } from '../../../entity-editor/utils/property-helpers';
import { BehaviorSubject, distinctUntilChanged, Observable } from 'rxjs';
import type { CombinedPropertyDetails } from '../../store/product-view/helpers/multi-edit-product.helpers';
import { Store } from '@ngrx/store';
import { createMultiEditPropertyEditorForProperty } from '../../store/product-view/product-view.selectors';
import type { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-multi-edit-property-editor',
  templateUrl: './multi-edit-property-editor.component.html',
  styleUrls: ['./multi-edit-property-editor.component.scss'],
  standalone: false
})
export class MultiEditPropertyEditorComponent implements OnChanges, PropertyEditorInputs {
  @Input() propertyType: PropertyType;
  @Input() entity: Entity;
  @Input() entityForm: UntypedFormGroup;

  @Output() propertyChange = new EventEmitter<EntityEditorPropertyChangedEvent>();

  private componentTypeSubject: BehaviorSubject<PropertyComponentType>;
  protected componentType$: Observable<PropertyComponentType>;
  protected propertyDetail$: Observable<CombinedPropertyDetails>;

  constructor(private store: Store) {
    this.componentTypeSubject = new BehaviorSubject<PropertyComponentType>(null);
    this.componentType$ = this.componentTypeSubject.asObservable().pipe(distinctUntilChanged());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['propertyType']?.currentValue) {
      this.componentTypeSubject.next(resolveComponentType(this.entity, this.propertyType));
      this.propertyDetail$ = this.store.select(createMultiEditPropertyEditorForProperty(this.propertyType.Key));
    }
  }

  protected checkboxClicked($event: MatCheckboxChange) {
    this.propertyChange.emit({
      propertyKey: this.propertyType.Key,
      value: $event.checked
    });
  }

  protected disabled(): boolean {
    const property = this.entity.Properties[this.propertyType.Key];
    return property.Rules.ReadOnlyIf || !property.Rules.EnableIf;
  }
}
